import { Icon, Logo } from '@livable/saas-react-components';
import { Box, Container, Grid, Link, Typography } from '@mui/material';
import React from 'react';
import LogoPng from 'src/img/logo_email.png';
import useStyles from '../../styles';
const headersExample = "\n<Typography variant=\"h1\">header text</Typography>";
const bodyBigExample = "\n<Typography variant=\"body3\" component=\"p\">body text</Typography>";
const bodyMiddleExample = "\n<Typography variant=\"body1\">body text</Typography>";
const bodySmallExample = "\n<Typography variant=\"body2\">body text</Typography>";
const typographyColorsExample = "\n<Typography variant=\"h4\" color=\"light\">body text</Typography>";
const fontHintsExample = "\n<Typography variant=\"formHint\" state=\"success\">\n  <Icon fontSize=\"small\" type=\"success\" />\n  Some unmet requirement.\n</Typography>";
const smallLogoExample = "\n/* 120x32px */\nimport { Logo } from '@livable/saas-react-components';\n<Logo />";
const logoExample = "\n/* 180x48px */\nimport { Logo } from '@livable/saas-react-components';\n<Logo size=\"medium\" />";
const pngLogoExample = "\n/* 180x48px png logo for emails */";
export default function LvTypography() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, /*#__PURE__*/React.createElement("span", null, "Typography "), /*#__PURE__*/React.createElement(Link, {
    href: "https://mui.com/material-ui/react-typography/#component",
    target: "_blank"
  }, "(documentation)")), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "App headlines"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    gutterBottom: true
  }, "H1 Header"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    gutterBottom: true
  }, "H2 Header"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    gutterBottom: true
  }, "H3 Header"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    gutterBottom: true
  }, "H4 Header"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, "H5 Header"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, "H6 Header"), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, headersExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    className: classes.subsectionName,
    gutterBottom: true
  }, "Body"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p",
    gutterBottom: true
  }, "Body/Big", /*#__PURE__*/React.createElement("br", null), "Esse in ex ullamco Lorem. Est sunt eu do ullamco reprehenderit deserunt est Lorem mollit", /*#__PURE__*/React.createElement("br", null), "laboris. Adipisicing incididunt voluptate aute consectetur officia..."), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, bodyBigExample), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    gutterBottom: true
  }, "Body/Medium", /*#__PURE__*/React.createElement("br", null), "Esse in ex ullamco Lorem. Est sunt eu do ullamco reprehenderit deserunt est Lorem mollit", /*#__PURE__*/React.createElement("br", null), "laboris. Adipisicing incididunt voluptate aute consectetur officia..."), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, bodyMiddleExample), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    gutterBottom: true
  }, "Body/Small", /*#__PURE__*/React.createElement("br", null), "Esse in ex ullamco Lorem. Est sunt eu do ullamco reprehenderit deserunt est Lorem mollit laboris.", /*#__PURE__*/React.createElement("br", null), "Adipisicing incididunt voluptate aute consectetur officia..."), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, bodySmallExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Typography colors"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "light",
    gutterBottom: true
  }, "Sample text (color=\"light\")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "disabled",
    gutterBottom: true
  }, "Sample text (color=\"disabled\")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "white",
    gutterBottom: true
  }, "Sample text (color=\"white\")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "dark",
    gutterBottom: true
  }, "Sample text (color=\"dark\")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "vibrant",
    gutterBottom: true
  }, "Sample text (color=\"vibrant\")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "error",
    gutterBottom: true
  }, "Sample text (color=\"error\")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "success",
    gutterBottom: true
  }, "Sample text (color=\"success\")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "info",
    gutterBottom: true
  }, "Sample text (color=\"info\")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "info-dark",
    gutterBottom: true
  }, "Sample text (color=\"info-dark\")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "warning",
    gutterBottom: true
  }, "Sample text (color=\"warning\")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    color: "primary",
    gutterBottom: true
  }, "Sample text (color=\"primary\")"), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, typographyColorsExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Form Hints"), /*#__PURE__*/React.createElement("div", {
    className: classes.hintsWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "formHint"
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small",
    type: "warning"
  }), "Some unmet requirement."), /*#__PURE__*/React.createElement(Typography, {
    variant: "formHint",
    state: "error"
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small",
    type: "warning"
  }), "Make sure it's at least 8 characters."), /*#__PURE__*/React.createElement(Typography, {
    variant: "formHint",
    state: "success"
  }, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small",
    type: "success"
  }), "Must contain at least 1 upper case, numeric, and special character.")), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, fontHintsExample)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    className: classes.subsectionName,
    gutterBottom: true
  }, "Logotype"), /*#__PURE__*/React.createElement(Logo, null), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, smallLogoExample), /*#__PURE__*/React.createElement(Logo, {
    size: "medium"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, logoExample), /*#__PURE__*/React.createElement("img", {
    src: LogoPng,
    width: "180",
    height: "48px",
    alt: "Livable logo",
    title: "Livable logo"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, pngLogoExample))))));
}